"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteAddress = deleteAddress;
var _checkoutUtils = require("@ori/checkout-utils");
var _constants = require("../constants");
var _getUrl = require("./getUrl");
/* eslint-disable @typescript-eslint/naming-convention -- HTTP header names */

/**
 * Using this instead of problematic usage of global API client for just 1 API call (for now).
 * But the global API client is still installed as a peer dependency of address-form anyway ...
 */
async function deleteAddress({
  addressId,
  currentLanguage,
  customerId,
  formattedToken,
  host,
  tenant
}) {
  let isMockup = false;
  if (process.env.NODE_ENV !== 'production') {
    isMockup = (0, _checkoutUtils.isDataMockup)(_constants.APP_NAME);
  }
  let basePath = `/customers/${customerId}/addresses/${addressId}`;

  // Simplified URL for local mock testing.
  if (isMockup) {
    basePath = '/customers/current/addresses/delete';
  }
  const headers = {
    'Content-Type': 'application/json; charset=utf-8'
  };
  return (0, _getUrl.getUrl)({
    basePath,
    currentLanguage,
    formattedToken,
    headers,
    host,
    isAuthorizationRequired: true,
    method: _checkoutUtils.HttpMethod.Delete,
    tenant
  });
}